import React, { useState } from "react";
import { useParams } from "react-router-dom";

import ReleasePreview from "./ReleasePreview";
import NewSingleTopics from "../../../features/topic-single/SingleTopics";

import { useAppSelector } from "../../../redux/hooks";
import { getAuthToken } from "../../../redux/reducers/auth";

import { CategoryState } from "../../../utils/CategoryState";
import { getLargestImage } from "../../../utils/GeneralUtils";
import { RequestState } from "../../../utils/RequestState";
import { useGetTopicsAdmin, useApproveTopic } from "../../../utils/useTopics";

const ReleaseTopicsPreviewContainer: React.FC = () => {
  const { id } = useParams<{ id: string }>();

  const [activeModal, setActiveModal] = useState<CategoryState>(
    CategoryState.None
  );
  const [requestState, setRequestState] = useState<RequestState>(
    RequestState.Pending
  );
  const [message, setMessage] = useState<string>("");

  const auth_token = useAppSelector(getAuthToken);

  const queryArgs = { auth_token: auth_token, id: id };

  const {
    topicsData: { items: topic },
    isLoading,
  } = useGetTopicsAdmin(queryArgs);
  const { mutateAsync, mutateLoading } = useApproveTopic([
    "topicsAdmin",
    queryArgs,
  ]);

  const handleInputChange = (value: string) => {
    setMessage(value);
  };

  const showModal = (modal: CategoryState) => {
    setActiveModal(modal);
  };

  const closeModal = () => {
    setActiveModal(CategoryState.None);
    setRequestState(RequestState.Pending);
  };

  const handleSubmit = async (approve: boolean) => {
    if (auth_token && id) {
      setRequestState(RequestState.Doing);

      await mutateAsync({
        auth_token: auth_token,
        id: id,
        message: message,
        approve: approve,
      });

      setRequestState(RequestState.Success);
    }
  };

  return (
    <ReleasePreview
      message={message}
      targetName={`${topic[0]?.name}`}
      modalLink={`/topics/${id}`}
      activeModal={activeModal}
      requestState={requestState}
      closeModal={closeModal}
      showModal={showModal}
      handleSubmit={handleSubmit}
      handleInputChange={handleInputChange}
      isLoading={isLoading || mutateLoading}
      releaseType={`トピックスタイトル`}
    >
      <NewSingleTopics
        imgSrc={getLargestImage(topic[0]?.imgs?.[0])}
        type={topic[0]?.topic_type?.name}
        date={topic[0]?.start_date}
        title={topic[0]?.name}
        game={topic[0]?.game}
        tags={topic[0]?.tags}
        content={topic[0]?.content?.blocks}
        authorName={topic[0]?.author_name}
        isPreview={true}
      />
    </ReleasePreview>
  );
};

export default ReleaseTopicsPreviewContainer;
